import { Injectable } from '@angular/core';
import { ENV } from '@app/env';
import { App, ViewController } from 'ionic-angular';

import { APP_CONFIG } from '../../app.config';

// tslint:disable-next-line: ban-types
declare var gtag: Function;
// tslint:disable-next-line: ban-types
declare var gtag_report_conversion: Function;

@Injectable()
export class AnalyticsService {

	constructor(
		private app: App
	) { }

	init(): void {
		this.listenPageChange();
		try {
			const script1: any = document.createElement('script');
			script1.async = true;
			script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + ENV.gaId;
			document.head.appendChild(script1);

			const script2: any = document.createElement('script');
			script2.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '` + ENV.gaId + `', {'send_page_view': false});
			`;

			if (ENV.mode == "PROD") {
				script2.innerHTML += `gtag('config', '` + ENV.registerFinishedConversionTag + `');`;
			}
			document.head.appendChild(script2);

			if (ENV.mode == "PROD") {
				const script3: any = document.createElement('script');
				script3.innerHTML = `
					function gtag_report_conversion(url) {
						var callback = function () {
							if (typeof(url) != 'undefined') {
								window.location = url;
							}
						};
						gtag('event', 'conversion', { 'send_to': 'AW-653257022/clOPCLG3qswBEL7Sv7cC', 'event_callback': callback });
						return false;
					}`;
				document.head.appendChild(script3);
			}
		} catch (ex) {
			console.error('Error appending google analytics');
			console.error(ex);
		}
	}

	event(eventName: string, category: string, label?: string, value?: number): void {
		try {
			gtag('event', eventName, {
				event_category: category,
				event_label: label || "",
				value: value || 1
			});
		} catch (error) {
			console.error(error);
		}
	}

	registerConversionEvent(): void {
		try {
			// gtag('event', 'conversion', { send_to: APP_CONFIG.GA_TAG_CONVERSION_VALUE });
			return gtag_report_conversion('https://app.fastget.com.br/#/establishment-registration');
		} catch (error) {
			console.error(error);
		}
	}

	exception(description: string): void {
		try {
			gtag('event', 'exception', {
				description: description,
				fatal: false
			});
		} catch (error) {
			console.error(error);
		}
	}

	trackView(): void {
		try {
			const path: string = "/" + location.hash;
			console.log(path);
			gtag('config', ENV.gaId, {
				// page_title: title,
				page_path: path
			});
		} catch (error) {
			console.error(error);
		}
	}

	private listenPageChange(): void {
		this.app.viewDidEnter.subscribe((view: ViewController) => {
			// console.log(view);
			if (view && !view.isOverlay) {
				if (view.instance && !view.instance.alreadyLoaded) {
					view.instance.alreadyLoaded = true;
					setTimeout(() => {
						this.trackView();
					}, 500);
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/analytics.service.ts